module.exports = __webpack_public_path__ + "img/qrCode_04.9dfd1372.jpg";